import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Estrategias específicas para cada franja del día: mañana, tarde y noche', 'La lista de los 10 gatillos silenciosos (como el café a cierta hora) y cómo ajustarlos', 'Un plan flexible de 14 días que se adapta a tu realidad, no al revés', 'Checklists y guías simples para medir tu progreso sin necesidad de una báscula', 'Combinaciones de meriendas que previenen los bajones de la tarde'];
  return <section className="py-24 bg-white px-4" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-4" data-id="element-13">
            ¿Qué Encontrarás Dentro de Esta Guía?
          </h2>
          <p className="text-lg text-sage font-medium" data-id="element-14">
            Este no es un simple ebook. Es una guía de acción, diseñada para la
            mujer práctica que quiere sentirse en control.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-15">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex items-start p-6 bg-cream rounded-xl border border-lightSage hover:border-gold/50 transition-colors duration-300" data-id="element-16">
              <CheckCircle className="w-6 h-6 text-sage flex-shrink-0 mt-1 mr-4" data-id="element-17" />
              <p className="text-lg text-warmBrown font-medium" data-id="element-18">{benefit}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}